var _rect, _path, _path2, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgUsFlag = function SvgUsFlag(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 10,
    viewBox: "0 0 14 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 10,
    fill: "#2F2F2F"
  })), /*#__PURE__*/React.createElement("g", {
    id: "FINAL - TOI - Revised Landing Page"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-226 -678C-226 -679.105 -225.105 -680 -224 -680H2093C2094.1 -680 2095 -679.105 2095 -678V983C2095 984.104 2094.1 985 2093 985H-224C-225.105 985 -226 984.105 -226 983V-678Z",
    fill: "#444444"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-224 -680V-679H2093V-680V-681H-224V-680ZM2095 -678H2094V983H2095H2096V-678H2095ZM2093 985V984H-224V985V986H2093V985ZM-226 983H-225V-678H-226H-227V983H-226ZM-224 985V984C-224.552 984 -225 983.552 -225 983H-226H-227C-227 984.657 -225.657 986 -224 986V985ZM2095 983H2094C2094 983.552 2093.55 984 2093 984V985V986C2094.66 986 2096 984.657 2096 983H2095ZM2093 -680V-679C2093.55 -679 2094 -678.552 2094 -678H2095H2096C2096 -679.657 2094.66 -681 2093 -681V-680ZM-224 -680V-681C-225.657 -681 -227 -679.657 -227 -678H-226H-225C-225 -678.552 -224.552 -679 -224 -679V-680Z",
    fill: "white",
    fillOpacity: 0.1
  })), /*#__PURE__*/React.createElement("g", {
    id: "TOI Landing Page"
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 375,
    height: 812,
    transform: "translate(-64 -511)",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Frame 1597883144"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 1597883155"
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: -40,
    y: -220,
    width: 327,
    height: 296,
    rx: 16,
    fill: "url(#paint0_linear_3839_1851)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: -39.5,
    y: -219.5,
    width: 326,
    height: 295,
    rx: 15.5,
    stroke: "url(#paint1_linear_3839_1851)",
    strokeOpacity: 0.1
  })), /*#__PURE__*/React.createElement("g", {
    id: "block"
  }, _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: -19.75,
    y: -19.75,
    width: 286.5,
    height: 75.5,
    rx: 9.75,
    fill: "white"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: -19.75,
    y: -19.75,
    width: 286.5,
    height: 75.5,
    rx: 9.75,
    stroke: "#ECEAEA",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Frame 1597883764"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 1597883761"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 1597883759"
  }, /*#__PURE__*/React.createElement("g", {
    id: "US"
  }, _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    id: "Mask",
    width: 14,
    height: 10,
    rx: 0.777778,
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3839_1851",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 14,
    height: 10
  }, _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    id: "Mask_2",
    width: 14,
    height: 10,
    rx: 0.777778,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3839_1851)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 511",
    d: "M14 10H0V9.33301H14V10ZM14 8.66602H0V7.99902H14V8.66602ZM14 7.33398H0V6.66699H14V7.33398ZM14 6H0V5.33301H14V6ZM14 4.66602H0V4H14V4.66602ZM14 3.33398H0V2.66699H14V3.33398ZM14 2H0V1.33398H14V2ZM14 0.666992H0V0H14V0.666992Z",
    fill: "#D02F44"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 511_2",
    width: 6,
    height: 4.66667,
    fill: "#46467F"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Oval 43",
    filter: "url(#filter0_d_3839_1851)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 3.33496C1.18395 3.33513 1.33301 3.48496 1.33301 3.66895C1.33281 3.85276 1.18383 4.00178 1 4.00195C0.816029 4.00195 0.666216 3.85287 0.666016 3.66895C0.666016 3.48485 0.815905 3.33496 1 3.33496ZM2.33301 3.33496C2.5171 3.33496 2.66699 3.48485 2.66699 3.66895C2.66679 3.85287 2.51698 4.00195 2.33301 4.00195C2.14921 4.00175 2.0002 3.85274 2 3.66895C2 3.48498 2.14909 3.33517 2.33301 3.33496ZM3.66699 3.33496C3.85109 3.33496 4 3.48485 4 3.66895C3.9998 3.85287 3.85096 4.00195 3.66699 4.00195C3.48307 4.0019 3.33419 3.85283 3.33398 3.66895C3.33398 3.48488 3.48294 3.33502 3.66699 3.33496ZM5 3.33496C5.18409 3.33496 5.33301 3.48485 5.33301 3.66895C5.33281 3.85287 5.18397 4.00195 5 4.00195C4.81608 4.0019 4.66719 3.85283 4.66699 3.66895C4.66699 3.48488 4.81595 3.33502 5 3.33496ZM1.66699 2.66797C1.85088 2.66821 2 2.81801 2 3.00195C1.99987 3.18579 1.8508 3.33471 1.66699 3.33496C1.48297 3.33496 1.33313 3.18594 1.33301 3.00195C1.33301 2.81786 1.4829 2.66797 1.66699 2.66797ZM3 2.66797C3.18389 2.66821 3.33301 2.81801 3.33301 3.00195C3.33288 3.18579 3.18381 3.33471 3 3.33496C2.81598 3.33496 2.66614 3.18594 2.66602 3.00195C2.66602 2.81786 2.81591 2.66797 3 2.66797ZM4.33301 2.66797C4.5171 2.66797 4.66699 2.81786 4.66699 3.00195C4.66687 3.18594 4.51703 3.33496 4.33301 3.33496C4.1491 3.33483 4.00013 3.18586 4 3.00195C4 2.81794 4.14902 2.6681 4.33301 2.66797ZM1 2.00195C1.18395 2.00212 1.33301 2.15097 1.33301 2.33496C1.33296 2.51891 1.18392 2.6678 1 2.66797C0.815936 2.66797 0.666066 2.51901 0.666016 2.33496C0.666016 2.15087 0.815905 2.00195 1 2.00195ZM2.33301 2.00195C2.5171 2.00195 2.66699 2.15087 2.66699 2.33496C2.66694 2.51901 2.51707 2.66797 2.33301 2.66797C2.14912 2.66776 2.00005 2.51889 2 2.33496C2 2.15099 2.14909 2.00216 2.33301 2.00195ZM3.66699 2.00195C3.85109 2.00195 4 2.15087 4 2.33496C3.99995 2.51901 3.85106 2.66797 3.66699 2.66797C3.48298 2.66791 3.33403 2.51898 3.33398 2.33496C3.33398 2.1509 3.48294 2.00201 3.66699 2.00195ZM5 2.00195C5.18409 2.00195 5.33301 2.15087 5.33301 2.33496C5.33296 2.51901 5.18406 2.66797 5 2.66797C4.81598 2.66791 4.66704 2.51898 4.66699 2.33496C4.66699 2.1509 4.81595 2.00201 5 2.00195ZM1.66699 1.33496C1.85086 1.33521 1.99997 1.48405 2 1.66797C2 1.85191 1.85088 2.00073 1.66699 2.00098C1.4829 2.00098 1.33301 1.85206 1.33301 1.66797C1.33303 1.4839 1.48291 1.33496 1.66699 1.33496ZM3 1.33496C3.18387 1.33521 3.33298 1.48405 3.33301 1.66797C3.33301 1.85191 3.18389 2.00073 3 2.00098C2.81591 2.00098 2.66602 1.85206 2.66602 1.66797C2.66604 1.4839 2.81592 1.33496 3 1.33496ZM4.33301 1.33496C4.51709 1.33496 4.66697 1.4839 4.66699 1.66797C4.66699 1.85206 4.5171 2.00098 4.33301 2.00098C4.14902 2.00085 4 1.85198 4 1.66797C4.00003 1.48398 4.14904 1.33509 4.33301 1.33496ZM1 0.667969C1.18389 0.66814 1.33291 0.817073 1.33301 1.00098C1.33301 1.18497 1.18395 1.33479 1 1.33496C0.815905 1.33496 0.666016 1.18507 0.666016 1.00098C0.666116 0.816967 0.815967 0.667969 1 0.667969ZM2.33301 0.667969C2.51704 0.667969 2.66689 0.816967 2.66699 1.00098C2.66699 1.18507 2.5171 1.33496 2.33301 1.33496C2.14909 1.33476 2 1.18494 2 1.00098C2.0001 0.817094 2.14915 0.668175 2.33301 0.667969ZM3.66699 0.667969C3.85103 0.667969 3.9999 0.816967 4 1.00098C4 1.18507 3.85109 1.33496 3.66699 1.33496C3.48294 1.33491 3.33398 1.18504 3.33398 1.00098C3.33408 0.817001 3.48301 0.668024 3.66699 0.667969ZM5 0.667969C5.18403 0.667969 5.33291 0.816967 5.33301 1.00098C5.33301 1.18507 5.18409 1.33496 5 1.33496C4.81595 1.33491 4.66699 1.18504 4.66699 1.00098C4.66709 0.817001 4.81601 0.668024 5 0.667969Z",
    fill: "url(#paint2_linear_3839_1851)"
  }))))))))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3839_1851",
    x: 0.666016,
    y: 0.667969,
    width: 4.66602,
    height: 3.72287,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.388889
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3839_1851"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3839_1851",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3839_1851",
    x1: 123.5,
    y1: -220,
    x2: 123.5,
    y2: 76,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF3F2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3839_1851",
    x1: -40,
    y1: -72,
    x2: 287,
    y2: -72,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8246FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6E64"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3839_1851",
    x1: 0.666016,
    y1: 0.667969,
    x2: 0.666016,
    y2: 4.00195,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0F0F0"
  })))));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgUsFlag);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/us-flag.e8c98694996c0bc0a391febdda2d0f63.svg";